import { render, staticRenderFns } from "./ProjectGroupViewForm.vue?vue&type=template&id=edc2b668&"
import script from "./ProjectGroupViewForm.vue?vue&type=script&lang=js&"
export * from "./ProjectGroupViewForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports